<template>
	<section>
		<painel-shell>
			<template v-slot:header-left>
				<navigation-header :title="$t('base.general.devices')" subtitle="We care about your well-being."></navigation-header>
			</template>
			<header-simple :space-top="false" :title="$t('base.general.devices')" :subtitle="'Information about the devices.'">
				<action-button :title="$t('buttons.actions.add_device')" @click="onButtonClick(TYPE_DEVICE)" />
				<action-group :has-button="true">
					<action-group-item-button @click="onButtonClick(TYPE_GROUP)" :title="$t('buttons.actions.add_group')" />
				</action-group>
			</header-simple>
			<user-watches-devices-list :user_uid="user_uid" />
		</painel-shell>
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="modalBox.title" :subHeader="$t('base.general.devices')">
			<form-group   v-if="isModalType(TYPE_GROUP)"   @done="onFormDone" :user_uid="user_uid" :action="modalBox.action" :group_id="modalBox.model_id" :type="groupFormType"/>
			<form-device  v-if="isModalType(TYPE_DEVICE)"  @done="onFormDone" :user_uid="user_uid" :action="modalBox.action" :device_id="modalBox.model_id"/>
		</modal-box>
	</section>
</template>

<script>
import NavigationHeader from '@/components/navigation/NavigationHeader'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import PainelShell from '@/modules/shell/PainelShell'
import FormTypes from './watches/FormTypes'
import UserWatchesDevicesList from './watches/UserWatchesDevicesList'
import FormGroup from './watches/UserWatchesFormGroup'
import FormDevice from './watches/UserWatchesFormDevice'
import ActionButton from '@/modules/ui/ActionButton'
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemLink from '@/modules/ui/ActionGroupItemLink'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'
export default {
	components: {
		PainelShell,
		UserWatchesDevicesList,
		FormGroup,
		FormDevice,
		NavigationHeader,
		HeaderSimple,
		ActionGroup,
		ActionGroupItemLink,
		ActionGroupItemButton,
		ActionButton
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			TYPE_GROUP: FormTypes.GROUP,
			TYPE_DEVICE: FormTypes.DEVICE,
			modalBox: {
				open: false,
				action: '',
				model_id: '',
				type: '',
				title: ''
			}
		}
	},
	computed: {
		groupFormType () {
			return FormTypes.DEVICE
		},
	},
	methods: {
		onButtonClick (type) {
			let open = true
			let action = 'add'
			switch (type) {
				case this.TYPE_GROUP:
					this.modalBox.title = this.$t('buttons.actions.add_group')
					break
				case this.TYPE_DEVICE:
					this.modalBox.title = this.$t('buttons.actions.add_device')
					break
				default:
					action = ''
					type = null
					open = false
			}
			this.modalBox.action = action
			this.modalBox.type = type
			this.modalBox.open = open
		},
		onEditGroup (group_id) {
			this.modalBox.action = 'edit'
			this.modalBox.model_id = group_id
			this.modalBox.type = this.TYPE_GROUP
			this.modalBox.title = this.$t('buttons.actions.edit_group')
			this.modalBox.open = open
		},
		onEditDevice (device_id) {
			this.modalBox.action = 'edit'
			this.modalBox.model_id = device_id
			this.modalBox.type = this.TYPE_DEVICE
			this.modalBox.title = this.$t('buttons.actions.edit_device')
			this.modalBox.open = open
		},
		onModalBoxClose () {
			this.modalBox.action = ''
			this.modalBox.model_id = ''
			this.modalBox.type = ''
			this.modalBox.title = ''
			this.modalBox.open = false
		},
		onFormDone () {
			this.onModalBoxClose()
			this.$store.dispatch('GET_PATIENTS', this)
		},
		isModalType (type) {
			return this.modalBox.type === type
		}
	},
	created () {
		this.$root.$on('editGroup', this.onEditGroup)
		this.$root.$on('editDevice', this.onEditDevice)
	},
	beforeDestroy () {
		this.$root.$off('editGroup', this.onEditGroup)
		this.$root.$off('editDevice', this.onEditDevice)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserDevices.vue